import * as React from "react";
function SvgMedicalCalendar(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 6.73h2v.958c0 .529.448.958 1 .958s1-.43 1-.958v-.959h6v.959c0 .529.448.958 1 .958s1-.43 1-.958v-.959h2v12.459H5V6.729zm12-1.917h4v14.375c0 1.058-.895 1.916-2 1.916H5c-1.105 0-2-.858-2-1.916V4.813h4V2.896h2v1.917h6V2.896h2v1.917zm-6 4.791v2.875H8v1.917h3v2.875h2v-2.875h3v-1.917h-3V9.604h-2z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgMedicalCalendar);
export default ForwardRef;
